// Override of Shopware's useContext helper.
//
// The upstream implementation depends on injectLocal/provideLocal and therefore
// can only run in Vue setup context. We need the same context values in Nuxt
// middleware/plugins as well, so we back it by Nuxt state.

import { unref } from 'vue';
import type { Ref } from 'vue';

type UseContextParams<T> = {
    context?: Ref<T> | T;
    replace?: T;
};

export function useContext<T>(injectionName: string, params?: UseContextParams<T>) {
    const state = useState<T | undefined>(`shopware-context:${injectionName}`, () =>
        params?.context !== undefined ? (unref(params.context) as T) : undefined
    ) as Ref<T>;

    if (params?.replace !== undefined) {
        state.value = unref(params.replace) as T;
    }

    if (params?.context !== undefined && typeof state.value === 'undefined') {
        state.value = unref(params.context) as T;
    }

    return state;
}
